import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from '@/views/HomeRouter.vue'
import GamePage from '@/views/GameRouter.vue'
import PreviousPage from '@/views/PreviousRouter.vue'
import qandapage from '@/views/qandapage.vue'
import sub2Page from '@/views/sub2Page.vue'
import sub3Page from '@/views/sub3Page.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/HomePage' // 直接重定向
  },
  {
    path: '/HomePage',
    component: HomePage
  },
  {
    path: '/GamePage',
    component: GamePage
  },
  {
    path: '/PreviousPage',
    component: PreviousPage
    // children: [
    //   {
    //     path: '#/PreviousPage/ApplyPage',
    //     component: ApplyPage
    //   }
    // ]
  },
  {
    path: '/qandaPage',
    component: qandapage
  },
  {
    path: '/sub2Page',
    component: sub2Page
  },
  {
    path: '/sub3Page',
    component: sub3Page
  }
]

const router = new VueRouter({
  routes,
  linkActiveClass: 'myClassActive'
})

export default router
